import {
  addBusiness,
  getBusiness,
  getBusinessByClient,
  getBusinessForBusinessUser,
  getBusinessWithClientId,
  searchBusiness,
  searchBusinessWithClient,
  setPageNumber,
  setRowsPerPage,
  updateBusiness,
  webScript,
  webScriptV2,
} from "../../store/business";
import useEntityList from "./useEntityList";

const BUSINESS_ACTIONS = {
  getBusinessAction: getBusiness,
  searchBusinessAction: searchBusiness,
  clientSearchAction: searchBusinessWithClient,
  addBusinessAction: addBusiness,
  updateBusinessAction: updateBusiness,
  setRowsPerPageAction: setRowsPerPage,
  setPageNumberAction: setPageNumber,
  webScriptAction: webScript,
  webScriptV2Action: webScriptV2,
  getBusinessByClientAction: getBusinessByClient,
  getBusinessWithClientAction: getBusinessWithClientId,
  getBusinessRoleAction: getBusinessForBusinessUser,
};

const selectBusinessExtras = (business) => ({
  scriptData: business?.scriptData ?? null,
  scriptVariants: business?.scriptVariants ?? null,
  businessData: business?.clientBusiness ?? null,
});

function useBusiness() {
  return useEntityList({
    stateKey: "business",
    listKey: "businessList",
    actionCreators: BUSINESS_ACTIONS,
    selectExtras: selectBusinessExtras,
  });
}

export default useBusiness;
